import type { MessageChannel, MessagingStatus } from '@/types/Models/MessagingProtection'

export function messageChannelLabel(channel: MessageChannel): string {
  return channel === 'sms' ? 'SMS' : 'Email'
}

export function messagingStatusLabel(status: MessagingStatus): string {
  const labels: Record<MessagingStatus, string> = {
    accepted: 'Accepted by provider',
    sending: 'Reserved · outcome unresolved',
    held: 'Held — not sent',
    cancelled: 'Cancelled',
    retry_requested: 'Recheck queued',
    unknown: 'Provider outcome unknown',
    not_sent: 'Not sent',
  }
  return labels[status] || status
}

export function deploymentReasonLabel(reason: string | null): string {
  const labels: Record<string, string> = {
    assignment_archived: 'Assignment is archived',
    shipment_collected_or_returned: 'Shipment has been collected or returned',
    collection_deadline_passed: 'Collection deadline has passed',
    provider_outcome_unknown: 'Provider outcome could not be confirmed',
  }
  return reason ? labels[reason] || reason : 'No invalid-message evidence'
}

export function messagingReviewNotice(status: MessagingStatus): string {
  if (status === 'held') return 'Still held: the message is not currently eligible.'
  if (status === 'cancelled') return 'Message cancelled.'
  if (status === 'retry_requested') return 'Eligibility passed. The message is queued for another check before sending.'
  return `Message status: ${messagingStatusLabel(status)}. Refresh before taking further action.`
}
